import { Module } from "vuex"

import { RootState } from "../index"

import ApiRequest from "@/utils/ApiRequest";

export enum UserRole {
    USER = 3,
    MODERATOR = 4,
    MANAGER = 2,
    MASTER_ADMIN = 1,
    GOD = 999,
}

export interface UserInfo {
    id: number;
    name: string;
    email: string | null;
    tel: string | null;
    has_pw2: boolean;
    has_qa: boolean;
    role: UserRole;
    coin: number;
    promotion_coin: number;
    point: number;
    is_lock: boolean;
    aff_code: string | null;
    aff_user_id: number | null;
    created_at?: string;
    updated_at?: string;
}

export const securityAsk = [
    'Bạn có thích đặt câu hỏi bảo mật không?',
    'Người yêu cũ bạn sinh ngày/tháng mấy?',
    'Người yêu mới bạn sinh năm bao nhiêu?',
    'Lần đầu bạn xem phim người lớn là khi nào?',
    'Bạn mắc phải bao nhiêu bệnh "lâu năm mà giấu"?',
    'Một ngày bạn phát ngôn không lịch sự bao nhiêu lần?',
];
export const optionsSecurityQuestion = securityAsk.map((v, i) => ({ value: (i + 1).toString(), label: v }));

interface UserState {
    data: UserInfo;
}

export enum StoreType {
    FETCH_USER = 'fetchUser',
}

export enum StoreMut {
    SET_USER = 'setUser',
}

export function isRole(state: UserState, permission: UserRole): boolean {
    return state.data.role === permission;
}

export const storageKey = 'user';

let isFetching = false;

export const store: Module<UserState, RootState> = {
    state: {
        data: {
            id: 0,
            name: '',
            email: null,
            tel: null,
            has_pw2: false,
            has_qa: false,
            role: UserRole.USER,
            coin: 0,
            promotion_coin: 0,
            point: 0,
            is_lock: false,
            aff_code: null,
            aff_user_id: null,
        },
    },

    mutations: {
        [StoreMut.SET_USER]: (state, user: UserInfo) => {
            state.data = user;

            // state.id = user.id;
            // state.name = user.name;
            // state.role = user.role;
            // state.coin = user.coin;
            // state.promotion_coin = user.promotion_coin;
            // state.point = user.point;
            // state.is_lock = user.is_lock;
            // state.aff_code = user.aff_code;
            // state.aff_user_id = user.aff_user_id;
            // state.created_at = user.created_at;
            // state.updated_at = user.updated_at;

            localStorage.setItem(storageKey, JSON.stringify(state.data));
        },
    },

    actions: {
        [StoreType.FETCH_USER]: async ({ commit }) => {
            if (isFetching) {
                throw new Error();
            }
            isFetching = true;
            try {
                const user: UserInfo = JSON.parse(localStorage.getItem(storageKey) || '{}');
                if (user.id) {
                    commit(StoreMut.SET_USER, user);
                }
            } catch (e) {
                // TODO: error handling
            }

            return ApiRequest.get('/user')
                .then(res => {
                    commit(StoreMut.SET_USER, res.data.data);
                })
                .finally(() => {
                    isFetching = false;
                });
        },
    },

    getters: {
        isLoggedIn(state) {
            return state.data.id > 0;
        },

        user(state) {
            return state.data;
        },

        hasGodPermission(state) {
            return isRole(state, UserRole.GOD);
        },

        hasMasterAdminPermission(state, getters) {
            return isRole(state, UserRole.MASTER_ADMIN) || getters.hasGodPermission;
        },

        hasManagerPermission(state, getters) {
            return isRole(state, UserRole.MANAGER) || getters.hasMasterAdminPermission;
        },

        hasModeratorPermission(state, getters) {
            return isRole(state, UserRole.MODERATOR) || getters.hasManagerPermission;
        },

        hasUserPermission(state, getters) {
            return isRole(state, UserRole.USER) || getters.hasModeratorPermission;
        },
    },
};
